import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { MailMessage_Interface } from 'src/app/Interface/MailMessage_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { MailMessageService } from 'src/app/Service/MailMessage/MailMessage.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-MailMessageList',
  templateUrl: './MailMessageList.component.html',
  styleUrls: ['./MailMessageList.component.scss']
})
export class MailMessageListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;
  modalRef_DeletePishPardakht: any;

  constructor(
    private MailMessage_Service:MailMessageService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_MailMessage:Array<MailMessage_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,44).subscribe(
      data=>{
        this.ReadData_MailMessage()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_MailMessage(){
    this.Procssing=true
    this.MailMessage_Service.GetRecord(this.Token,0).subscribe(
      data=>{
        this.DataList_MailMessage=data
        this.Procssing=false
      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.MailMessage_Service.DeleteMail_Message(item.id,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
        this.ReadData_MailMessage()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  PishPardakht(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.MailMessage_Service.PishPardakht(item.id,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.ReadData_MailMessage()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  openModalPishPardakht(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_DeletePishPardakht = this.modalService.show(template);
  }

}
